import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roomsRateList: [],
  roomsSeasonalRateList: [],
  roomRateDetail: null,
  roomSeasonalRateDetail: null,
  accommodationList: [],
  roomCategoryTypes: [],
  suggestedHotelList: [],
  marketHotelList: [],
  propertyId: null,
  rateOverviewEventss: [],
  handleRateTrigger: false,
  rateApiLoading: {
    resultAvailLoading: false,
    resultMinStayData: false,
    resultLoading: false,
    suggestedResultLoading: false,
  },
  rateSuggestedResultData: [],
  rateResult: {},
  rateResultAvail: {},
  rateResultMinStay: {},
  roomRateIdData: [],
  otaOverviewEventss: [],
  handleOtaTrigger: false,
  otaApiLoading: {
    availabilityLoading: false,
    otaAvailInvLoading: false,
    resultLoading: false,
    suggestedResultLoading: false,
    roomRateCateLoading: false,
  },
  otaInventoryOverviewEventss: [],
  handleOtaInventoryTrigger: false,
  otaInventoryApiLoading: {
    availabilityLoading: false,
    otaAvailInvLoading: false,
    roomRateCateLoading: false,
  },
  otaSuggestedResultData: [],
  otaAvailabilityData: [],
  otaAvailInv: {},
  otaResult: {},
  otaRoomRateCate: [],
  otaRoomRateIdData: [],
};
const roomRateSlice = createSlice({
  name: "roomRate",
  initialState: initialState,
  reducers: {
    roomCategoryTypesSuccess: (state, action) => {
      state.roomCategoryTypes = action.payload;
    },
    roomCategoryTypesFailed: (state, action) => {
      state.roomCategoryTypes = [];
    },
    roomsRateListSuccess: (state, action) => {
      state.roomsRateList = action.payload;
    },
    roomsRateListFailed: (state, action) => {
      state.roomsRateList = [];
    },
    suggestedHotelListSuccess: (state, action) => {
      state.suggestedHotelList = action.payload;
    },
    suggestedHotelListFailed: (state, action) => {
      state.suggestedHotelList = [];
    },
    marketHotelListSuccess: (state, action) => {
      state.marketHotelList = action.payload;
    },
    marketHotelListFailed: (state, action) => {
      state.marketHotelList = [];
    },
    roomsSeasonalRateListSuccess: (state, action) => {
      state.roomsSeasonalRateList = action.payload;
    },
    roomsSeasonalRateListFailed: (state, action) => {
      state.roomsSeasonalRateList = [];
    },
    accommodationListSuccess: (state, action) => {
      state.accommodationList = action.payload;
    },
    accommodationListFailed: (state, action) => {
      state.accommodationList = [];
    },
    roomRateDetailSuccess: (state, action) => {
      state.roomRateDetail = action.payload;
    },
    roomRateDetailFailed: (state, action) => {
      state.roomRateDetail = null;
    },
    roomSeasonalRateDetailSuccess: (state, action) => {
      state.roomSeasonalRateDetail = action.payload;
    },
    roomSeasonalRateDetailFailed: (state, action) => {
      state.roomSeasonalRateDetail = null;
    },
    propertyIdSuccess: (state, action) => {
      state.propertyId = action.payload;
    },
    propertyIdFailed: (state, action) => {
      state.propertyId = "";
    },
    rateOverviewEventssSuccess: (state, action) => {
      state.rateOverviewEventss = action.payload;
    },
    rateSuggestedResultDataSuccess: (state, action) => {
      state.rateSuggestedResultData = action.payload;
    },
    rateResultSuccess: (state, action) => {
      state.rateResult = action.payload;
    },
    rateResultAvailSuccess: (state, action) => {
      state.rateResultAvail = action.payload;
    },
    rateResultMinStaySuccess: (state, action) => {
      state.rateResultMinStay = action.payload;
    },
    roomRateIdDataSuccess: (state, action) => {
      state.roomRateIdData = action.payload;
    },
    handleRateTriggerSuccess: (state, action) => {
      state.handleRateTrigger = true;
    },
    handleRateTriggerFailed: (state, action) => {
      state.handleRateTrigger = false;
    },
    rateApiLoadingSuccess: (state, action) => {
      state.rateApiLoading = {...state.rateApiLoading, [action.payload]: true }
    },
    rateApiLoadingFailed: (state, action) => {
      state.rateApiLoading = {...state.rateApiLoading, [action.payload]: false }
    },
    handleOtaTriggerSuccess: (state, action) => {
      state.handleOtaTrigger = true;
    },
    handleOtaTriggerFailed: (state, action) => {
      state.handleOtaTrigger = false;
    },
    otaApiLoadingSuccess: (state, action) => {
      state.otaApiLoading = {...state.otaApiLoading, [action.payload]: true }
    },
    otaApiLoadingFailed: (state, action) => {
      state.otaApiLoading = {...state.otaApiLoading, [action.payload]: false }
    },
    otaOverviewEventssSuccess: (state, action) => {
      state.otaOverviewEventss = action.payload;
    },
    otaSuggestedResultDataSuccess: (state, action) => {
      state.otaSuggestedResultData = action.payload;
    },
    otaAvailabilityDataSuccess: (state, action) => {
      state.otaAvailabilityData = action.payload;
    },
    otaAvailInvSuccess: (state, action) => {
      state.otaAvailInv = action.payload;
    },
    otaResultSuccess: (state, action) => {
      state.otaResult = action.payload;
    },
    otaRoomRateCateSuccess: (state, action) => {
      state.otaRoomRateCate = action.payload;
    },
    otaRoomRateIdDataSuccess: (state, action) => {
      state.otaRoomRateIdData = action.payload;
    },
  },
});

export const {
  roomCategoryTypesSuccess,
  roomCategoryTypesFailed,
  roomsRateListSuccess,
  roomsRateListFailed,
  suggestedHotelListFailed,
  suggestedHotelListSuccess,
  marketHotelListFailed,
  marketHotelListSuccess,
  roomRateDetailSuccess,
  roomRateDetailFailed,
  accommodationListSuccess,
  accommodationListFailed,
  roomSeasonalRateDetailSuccess,
  roomSeasonalRateDetailFailed,
  roomsSeasonalRateListSuccess,
  roomsSeasonalRateListFailed,
  propertyIdSuccess,
  propertyIdFailed,
  rateOverviewEventssSuccess,
  rateSuggestedResultDataSuccess,
  rateResultSuccess,
  rateResultAvailSuccess,
  rateResultMinStaySuccess,
  handleRateTriggerSuccess,
  handleRateTriggerFailed,
  rateApiLoadingSuccess,
  rateApiLoadingFailed,
  roomRateIdDataSuccess,
  handleOtaTriggerSuccess,
  handleOtaTriggerFailed,
  otaApiLoadingSuccess,
  otaApiLoadingFailed,
  otaOverviewEventssSuccess,
  otaSuggestedResultDataSuccess,
  otaAvailabilityDataSuccess,
  otaAvailInvSuccess,
  otaResultSuccess,
  otaRoomRateCateSuccess,
  otaRoomRateIdDataSuccess,
  otaRoomRateIdData
} = roomRateSlice.actions;
export default roomRateSlice.reducer;
